/**
 * Declares a `data-help` anchor whose attribute is applied dynamically — inside a `.map`
 * over columns, or spread onto a component that forwards props.
 *
 * `scripts/help-check.mjs` scans source text for string literals, so a
 * `data-help={column.help}` is invisible to it and its guide step would be reported as an
 * orphan. Wrapping the value in this call puts the literal back in the source in a form
 * the checker recognises: it matches both `data-help="…"` and `helpAnchor('…')`.
 *
 * Use a plain `data-help="…"` attribute wherever the value can be written inline — this
 * exists for the cases where it cannot.
 */
export const helpAnchor = (name: string): string => name;
